import React from 'react';
import { IMoney } from '@williamhill/rosi-ui-shared/src/lib/money';
import { IBet } from '../types';
import { unitsValueMoney, zeroMoney } from '@williamhill/rosi-ui-shared/src/lib/money';

export const currencySymbols = {
  GBP: '£',
  USD: '$',
  CAD: '$'
};

export const formatMoneyWithSymbol = (amount: IMoney, symbol: string, ignoreOperator?: boolean): string => {
  const operator = amount.isNegative() ? '-' : '';
  return `${ignoreOperator ? '' : operator}${symbol}${amount.abs().toFormattedString()}`;
};

export const formatMoneyWithSymbolNoDecimal = (amount: IMoney, symbol: string, ignoreOperator?: boolean): string => {
  const operator = amount.isNegative() ? '-' : '';
  return `${ignoreOperator ? '' : operator}${symbol}${amount.toFormattedStringNoDecimals()}`;
};

export const styleMoneyWithDefaultCurrency = (amount: IMoney, className?: string) => {
  const calculatedBalance = formatMoneyWithSymbol(amount, '$');
  const style = amount.isNegative() ? { color: '#d0021b' } : {};
  return (
    <span style={style} className={className}>
      {calculatedBalance}
    </span>
  );
};
export const getReturns = ({
  status,
  payout,
  potentialReturns
}: Pick<IBet, 'status' | 'payout' | 'potentialReturns'>) =>
  status === 'settled' || status === 'cancelled' ? payout : potentialReturns;

export const getFormattedStake = (bet: IBet) => formatMoneyWithSymbol(bet.totalStake, '$');

export const getFormattedWinnings = (bet: Parameters<typeof getReturns>[0] & Pick<IBet, 'totalStake'>) => {
  const winningsMoney = getReturns(bet).sub(bet.totalStake);
  return formatMoneyWithSymbol(winningsMoney.isNegative() ? zeroMoney() : winningsMoney, '$');
};

export const getFormattedReturns = (bet: Parameters<typeof getReturns>[0]) =>
  formatMoneyWithSymbol(getReturns(bet), '$');

export const formatNumberMoney = (value: number) => formatMoneyWithSymbol(unitsValueMoney(value), '$');
